import { useSearchParams } from "react-router-dom";

export const useFilterState = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateSearchParams = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);

    if (key !== "page") {
      newSearchParams.set("page", "1");
    }
    if (key === "country") {
      newSearchParams.delete("city");
    }
    // -1 for all
    if (value === -1) {
      newSearchParams.delete(key);
    } else if (value) {
      newSearchParams.set(key, encodeURIComponent(value.toString()));
    } else {
      newSearchParams.delete(key);
    }
    setSearchParams(newSearchParams);
  };

  const getDecodedSearchParams = key => {
    const value = searchParams.get(key);
    return value ? decodeURIComponent(value) : "";
  };

  return {
    setSelectedCountry: value => updateSearchParams("country", value),
    setSelectedCity: value => updateSearchParams("city", value),
    setSelectedType: value => updateSearchParams("type", value),
    setSelectedValue: value => updateSearchParams("google", value),
    selectedCountry: getDecodedSearchParams("country"),
    selectedCity: getDecodedSearchParams("city"),
    selectedType: getDecodedSearchParams("type"),
    selectedValue: getDecodedSearchParams("google"),
  };
};
